module.exports = __webpack_public_path__ + "img/tema-1-5.b57034b9.svg";